function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["children", "className", "disabled", "icon", "iconProps", "label", "loaderLabel", "loaderProps", "loading", "look", "showIconButton"],
  _excluded2 = ["look", "showIconButton"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { forwardRef, useState, useEffect, useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import { ButtonVariants, ButtonLooks } from "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import { LoaderSizes } from "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import { baseButtonStyle, getButtonTheme } from "../../../../styles/styled-components/button.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import { getLoaderLookFromButtonLook } from "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import { screenReaderOnly } from "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import { FontIcon } from "../../icon/font-icon/font-icon.js";
import { CircleLoader } from "../../loader/circle-loader/circle-loader.js";
import "../../loader/shimmer-loader/shimmer-loader.js";
import { BaseButton } from "../base-button/base-button.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BaseIconButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classnames;
  var children = props.children,
    className = props.className,
    disabled = props.disabled,
    icon = props.icon,
    iconProps = props.iconProps,
    label = props.label,
    loaderLabel = props.loaderLabel,
    loaderProps = props.loaderProps,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    look = props.look,
    showIconButton = props.showIconButton,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(getLoaderLookFromButtonLook(look)),
    _useState2 = _slicedToArray(_useState, 2),
    loaderLook = _useState2[0],
    setLoaderLook = _useState2[1];
  useEffect(function () {
    setLoaderLook(getLoaderLookFromButtonLook(look));
  }, [loading, look]); // eslint-disable-line react-hooks/exhaustive-deps
  return /*#__PURE__*/React.createElement(BaseButton, _extends({}, otherProps, {
    "aria-label": label,
    className: classnames((_classnames = {
      'bf-button__icon--disabled': disabled,
      'bf-button__icon--hidden': !showIconButton
    }, _defineProperty(_classnames, "bf-button__icon--".concat(icon), icon), _defineProperty(_classnames, "bf-button__icon--".concat(look), look), _defineProperty(_classnames, "".concat(className), className), _classnames)),
    disabled: disabled,
    loading: loading,
    ref: ref,
    variant: ButtonVariants.Icon
  }), loading && loaderLabel ? /*#__PURE__*/React.createElement(CircleLoader, _extends({
    buttonLook: look,
    label: loaderLabel,
    look: loaderLook,
    size: LoaderSizes.Small
  }, loaderProps, {
    className: classnames(_defineProperty({
      'bf-button__standard__loader': true
    }, "".concat(loaderProps === null || loaderProps === void 0 ? void 0 : loaderProps.className), !!(loaderProps !== null && loaderProps !== void 0 && loaderProps.className)))
  })) : icon ? /*#__PURE__*/React.createElement(FontIcon, _extends({}, iconProps, {
    className: classnames(_defineProperty({
      'bf-button__font-icon': true
    }, "".concat(iconProps === null || iconProps === void 0 ? void 0 : iconProps.className), iconProps === null || iconProps === void 0 ? void 0 : iconProps.className)),
    icon: icon
  })) : children);
});
var Button = styled(BaseIconButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  padding: ", ";\n  ", "\n\n  .bf-button__font-icon {\n    font-size: 14px;\n  }\n"])), baseButtonStyle, function (_ref) {
  var look = _ref.look;
  return getButtonTheme({
    look: look
  });
}, function (_ref2) {
  var loading = _ref2.loading;
  return loading ? '12px' : '15px';
}, function (_ref3) {
  var showIconButton = _ref3.showIconButton;
  return showIconButton ? '' : screenReaderOnly;
});
var IconButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$look = props.look,
    look = _props$look === void 0 ? ButtonLooks.Primary : _props$look,
    _props$showIconButton = props.showIconButton,
    showIconButton = _props$showIconButton === void 0 ? true : _props$showIconButton,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Button, _extends({}, otherProps, {
    look: look,
    ref: ref,
    showIconButton: showIconButton
  })));
});
export { BaseIconButton, IconButton };